module.exports = "/src/views/player/documets/lspdbadge/images/6.png";